import React from 'react'
import { Images } from '../../assets/images'
interface ThinkingBubbleProps {
  show: boolean
  elapsed: number
  done?: boolean
}

function formatElapsed(total: number) {
  if (total < 60) return `${total}s`
  const m = Math.floor(total / 60)
  const s = total % 60
  return `${m}:${String(s).padStart(2, '0')}`
}

export const ThinkingBubble: React.FC<ThinkingBubbleProps> = ({
  show,
  elapsed,
  done = false,
}) => {
  if (!show) return null

  return (
    <div className="message-container thinking">
      <div className="message-avatar-image-container">
        <img
          src={Images.bot}
          alt="Osirus"
          className={`message-avatar-image ${done ? '' : 'thinking-spinner'}`}
          width={40}
          height={40}
        />
      </div>

      <div className="thinking-content">
        <div className="thinking-line">{done ? 'Thought' : 'Thinking...'}</div>
        <div className="thinking-time">({formatElapsed(elapsed)})</div>
      </div>
    </div>
  )
}
